module.exports = __webpack_public_path__ + "dba92cb9dc60f9f35cbf62428afd3ac1.ttf";